// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3197":"3fac0136","4118":"a653ec44","4282":"a4fe211c","8216":"5992af4e","8655":"2d799ea2"}[chunkId] + ".chunk.css";
};